import Constant from '@/const';
import axios from 'axios';

const putStatusServices = async payload => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/service/status`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putStatusServices;
